export { default as DynamicFrequentlyAskedQuestions } from './DynamicFrequentlyAskedQuestions'
export { default } from './FrequentlyAskedQuestions'
